// extracted by mini-css-extract-plugin
export var Pagination = "ReviewSection-module--Pagination--88420";
export var Reviews = "ReviewSection-module--Reviews--77deb";
export var ReviewsContainer = "ReviewSection-module--ReviewsContainer--6f67e";
export var write = "ReviewSection-module--write--d0afc";